import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { ForgotPasswordComponent } from './forgot-password.component';

// TODO - remove when forgotPassword ngx STAB-628
export const ngxForgotPasswordModule = angular.module('ngxForgotPasswordModule', [])
	.directive('ngxForgotPassword', downgradeComponent({ component: ForgotPasswordComponent }))
	.name;
